export default __webpack_public_path__ + "static/media/V350MANB5.b0349403.pdf";